import clsx from 'clsx';
import {
  CalendarDays,
  CalendarRange,
  Settings,
  Sun,
  Users,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppStore } from '@/app/store';
import styles from './BottomNav.module.css';

const TABS = [
  { key: 'today' as const, path: '/app/today', icon: Sun, labelKey: 'nav.today' },
  { key: 'calendar' as const, path: '/app/calendar', icon: CalendarDays, labelKey: 'nav.calendar' },
  { key: 'month' as const, path: '/app/month', icon: CalendarRange, labelKey: 'nav.monthPlans' },
  { key: 'shared' as const, path: '/app/shared', icon: Users, labelKey: 'nav.shared' },
  { key: 'settings' as const, path: '/app/settings', icon: Settings, labelKey: 'nav.settings' },
];

export function BottomNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const setMobileTab = useAppStore((s) => s.setMobileTab);

  return (
    <nav className={clsx('chrome-surface', styles.nav)} aria-label={t('shortcuts.navigate')}>
      {TABS.map(({ key, path, icon: Icon, labelKey }) => {
        const active = location.pathname === path || (path === '/app/calendar' && location.pathname === '/app');
        return (
          <button
            key={key}
            type="button"
            className={clsx(styles.tab, active && styles.active)}
            onClick={() => {
              setMobileTab(key);
              navigate(path);
            }}
            aria-current={active ? 'page' : undefined}
          >
            <Icon size={20} aria-hidden="true" />
            <span>{t(labelKey)}</span>
          </button>
        );
      })}
    </nav>
  );
}
